import { render, staticRenderFns } from "./Ausencia.vue?vue&type=template&id=78b1a080"
import script from "./Ausencia.vue?vue&type=script&lang=js"
export * from "./Ausencia.vue?vue&type=script&lang=js"
import style0 from "./Ausencia.vue?vue&type=style&index=0&id=78b1a080&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports